var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("transition", { attrs: { name: "fade", appear: "" } }, [
    _c(
      "div",
      { staticClass: "custom-fields-empty-message-container" },
      [
        _c("div", { staticClass: "empty-message-title" }, [
          _vm._v(_vm._s(_vm.texts.title)),
        ]),
        _c("i18n", {
          staticClass: "empty-message-text",
          attrs: { path: _vm.texts.text, tag: "div" },
          scopedSlots: _vm._u([
            {
              key: "link",
              fn: function () {
                return [
                  _c(
                    "router-link",
                    { attrs: { to: _vm.configurationPanelUrl } },
                    [_vm._v(_vm._s(_vm.texts.configurationPanel))]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }